export default __webpack_public_path__ + "static/media/preflop-equity-handvshand_0016_thumb.cf471933.jpg";